import { DJ_CONSOLE_POLL_INTERVAL_MS } from '@mixwire/contracts';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { fetchDjView } from '../api/client.js';
import { djViewQueryKey } from '../api/queryKeys.js';
import { useReportPoll } from '../sync/usePollCycle.js';

import type { ChannelId, DjView, PartySlug } from '@mixwire/contracts';

export { djViewQueryKey } from '../api/queryKeys.js';

export const useDjView = (slug: PartySlug, channelId: ChannelId): UseQueryResult<DjView> => {
  const query = useQuery({
    queryKey: djViewQueryKey(slug, channelId),
    queryFn: async () => fetchDjView(slug, channelId),
    staleTime: 0,
    refetchInterval: (current) =>
      current.state.data?.sync.nextPollInMs ?? DJ_CONSOLE_POLL_INTERVAL_MS,
  });

  useReportPoll(query.data?.sync, query.dataUpdatedAt);

  return query;
};
